exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-inner[data-v-a6bc0be4] {\n\theight:100vh;\n\tdisplay:flex;\n\tjustify-content:center;\n\talign-items:center;\n\tflex-direction: column;\n}\na[data-v-a6bc0be4] {\n    text-decoration: underline;\n    font-size: 1.5rem;\n    margin-top: 2rem;\n}\n", ""]);

// exports
